import "./index.scss";
import Main from "./Components/Main";

import ReactDOM from "react-dom/client";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<Main />);
